import { Route } from 'src/routes/Route'

export const CertifiedCoachingRoute = Route({
  path: '/certified-coaching',
})
export type CertifiedCoachingRoute = Route<typeof CertifiedCoachingRoute>
